import scrollTo from './common/scrollTo';
import { on } from 'delegated-events';

const SELECTORS = Selectors({
  list: '.blog-list',
  pagination: '.blog-pagination',
  more: '.blog-pagination__more',
  less: '.blog-pagination__less',
});

let currentPage = 1;
const PAGE_LENGTH = 6;
const blogList = document.querySelector(SELECTORS.list);
const blogPagination = document.querySelector(SELECTORS.pagination);
const blogPaginationMore = document.querySelector(SELECTORS.more);
const blogPaginationLess = document.querySelector(SELECTORS.less);

const fn = {
  init: () => {
    fn.handleBlogPagination();
    fn.bindEvents();
  },

  bindEvents: () => {
    // blogPaginationMore.on('click', () => {});

    on('click', SELECTORS.more, () => {
      currentPage = currentPage + 1;
      fn.handleBlogPagination();
    });

    // blogPaginationLess.on('click', () => {});

    on('click', SELECTORS.less, () => {
      currentPage = 1;
      fn.handleBlogPagination();
      scrollTo(SELECTORS.list, 150);
    });
  },

  handleBlogPagination: () => {
    const blogListItems = blogList.querySelectorAll('li');
    const total = blogListItems.length;
    const hiddenIndex = currentPage * PAGE_LENGTH;

    if (total > PAGE_LENGTH) {
      blogListItems.forEach((el, index) => {
        if (index >= hiddenIndex) {
          el.classList.add('is-hidden');
        } else {
          el.classList.remove('is-hidden');
        }
      });
    }

    const currentCount = blogList.querySelectorAll('li:not(.is-hidden)').length;
    blogPagination.querySelector('.blog-pagination__current').innerHTML = currentCount;

    if (total < PAGE_LENGTH) {
      blogPagination.querySelector('.blog-pagination__actions').classList.add('is-hidden');
    } else {
      blogPagination.querySelector('.blog-pagination__actions').classList.remove('is-hidden');
    }
    // blogPaginationMore.classList.toggle('is-hidden', blogList.querySelectorAll('li.is-hidden').length <= 0);
    if (blogList.querySelectorAll('li.is-hidden').length <= 0) {
      blogPaginationMore.classList.add('is-hidden');
    } else {
      blogPaginationMore.classList.remove('is-hidden');
    }
    // blogPaginationLess.classList.toggle('is-hidden', currentPage <= 1);
    if (currentPage <= 1) {
      blogPaginationLess.classList.add('is-hidden');
    } else {
      blogPaginationLess.classList.remove('is-hidden');
    }
  },
};

export default {
  can: () => document.body.classList.contains('page-blog'),
  // can: () => false,
  run: fn.init,
};
